export const DE_LANG = {
    COMMON_UI: {
        NOTIFICATIONS: {
            SAVE_ERROR: {
                TITEL: 'Beim automatischen Speichern Ihrer Eingaben ist ein Fehler aufgetreten',
                MESSAGE: 'Bitte führen Sie die letzte Aktion erneut aus.'
            },
            CONVERTER_ERROR: {
                TITEL: 'Die Plausibilitätsprüfung Ihrer Angaben konnte nicht durchgeführt werden',
                MESSAGE: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
            },
            CHECK_ERROR: {
                TITEL: 'Die Plausibilitätsprüfung Ihrer Angaben konnte nicht durchgeführt werden',
                MESSAGE: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
            },
            SEND_ERROR: {
                TITEL: 'Ihr Fragebogen konnte nicht versendet werden',
                MESSAGE: 'Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
            },
            PREVIEW_ERROR: {
                TITEL: 'preview error titel xxx',
                MESSAGE: 'preview error message xxx.'
            }
        },
        NAVIGATION: {
            BUTTON_TEXT: 'Zur Übersicht',
            WEITER_BUTTON: 'Weiter',
            VALIDATE_BUTTON: 'Eingaben prüfen',
            ZURUECK_BUTTON: 'Zurück',
            NACHREICHUNG_ANGABEN: 'Nachzureichende Unterlagen',
            VALIDATE_SUCCESS_MESSAGE: 'Es wurden keine Fehler gefunden.'
        },
        GENERAL_MESSAGE_BANNER:{
            TEXT:'Die DATEV Fragebögen zur steuerlichen Erfassung werden demnächst auf die neue Version der Finanzverwaltung umgestellt. ' +
              'Wir empfehlen Ihnen, Ihre Entwürfe vor dem 23.04.2026 zu übermitteln.'
        },
        CARDS: {
            DANGER_CARD: {
                IMG_ALT: 'Fehler'
            }
        },
        FOOTER: {
            COPYRIGHT: 'DATEV eG',
            IMPRINT: 'Impressum',
            LICENSE: 'Nutzungsbedingungen',
            PRIVACY: 'Datenschutz'
        },
        PERSONENSTAMMDATEN: {
            ANREDE: {
                LABEL: 'Anrede',
                NULL: 'Bitte wählen',
                KEY_1: 'Herr',
                KEY_2: 'Frau'
            },
            ANREDE_TITEL: 'Anrede, Titel',
            TITEL: 'Titel',
            VORNAME: 'Vorname',
            NACHNAME: 'Nachname',
            NAMENSVORSATZ: 'Namensvorsatz',
            NAMENSZUSATZ: 'Namenszusatz',
            NAMENSVORSATZ_ZUSATZ: 'Namensvor-/zusatz'
        },
        JURISTISCHEPERSON: {
            FIRMENNAME: 'Name',
            ANREDE: {
                LABEL: 'Anrede',
                KEY_1: 'Firma'
            }
        },
        JURISTISCHEPERSON_KAPG: {
          FIRMENNAME: 'Name (Firma laut Register)'
        },
        ADRESSEN: {
            TITEL: 'Adresse',
            INLANDSADRESSE: {
                TITEL: 'Inlandsadresse',
                STR_HNR_ZUS: 'Straße, Nr., Zusatz',
                STRASSE: 'Straße',
                HAUSNUMMER: 'Hausnummer',
                HAUSNUMMERNZUSATZ: 'Hausnummernzusatz',
                ADRESSERGAENZUNG: 'Anschriftenzusatz',
                PLZ_ORT: 'Postleitzahl, Ort',
                PLZ: 'Postleitzahl',
                ORT: 'Ort'
            },
            AUSLANDSADRESSE: {
                TITEL: 'Auslandsadresse',
                STR_HNR_ZUS: 'Straße, Nr., Zusatz',
                STRASSE: 'Straße',
                HAUSNUMMER: 'Hausnummer',
                HAUSNUMMERNZUSATZ: 'Hausnummernzusatz',
                ADRESSERGAENZUNG: 'Anschriftenzusatz',
                PLZ_ORT: 'Postleitzahl, Ort',
                PLZ: 'Postleitzahl',
                ORT: 'Ort',
                LAND: {
                    LABEL: 'Land',
                    NULL: 'Bitte wählen',
                    KEY_660: 'Afghanistan',
                    KEY_220: 'Ägypten',
                    KEY_070: 'Albanien',
                    KEY_208: 'Algerien',
                    KEY_832: 'Amerik. Überseeinseln',
                    KEY_830: 'Amerik.-Samoa',
                    KEY_457: 'Amerikan. Jungferninseln',
                    KEY_043: 'Andorra',
                    KEY_330: 'Angola',
                    KEY_446: 'Anguilla',
                    KEY_891: 'Antarktis',
                    KEY_459: 'Antigua und Barbuda',
                    KEY_310: 'Äquatorialguinea',
                    KEY_608: 'Arabische Republik Syrien',
                    KEY_528: 'Argentinien',
                    KEY_077: 'Armenien',
                    KEY_474: 'Aruba',
                    KEY_078: 'Aserbaidschan',
                    KEY_334: 'Äthiopien',
                    KEY_800: 'Australien',
                    KEY_802: 'Australisch-Ozeanien',
                    KEY_453: 'Bahamas',
                    KEY_640: 'Bahrain',
                    KEY_666: 'Bangladesch',
                    KEY_469: 'Barbados',
                    KEY_073: 'Belarus (Weißrussland)',
                    KEY_017: 'Belgien',
                    KEY_421: 'Belize',
                    KEY_284: 'Benin (ehem. Dahome)',
                    KEY_413: 'Bermuda',
                    KEY_625: 'Besetzte palästinensische Gebiete',
                    KEY_675: 'Bhutan',
                    KEY_516: 'Bolivien',
                    KEY_475: 'Bonaire',
                    KEY_093: 'Bosnien und Herzegowina',
                    KEY_391: 'Botsuana',
                    KEY_892: 'Bouvet-Inseln',
                    KEY_508: 'Brasilien',
                    KEY_468: 'Brit. Jungferninseln',
                    KEY_357: 'Brit. Territorium im Ind. Ozean',
                    KEY_703: 'Brunei Darussalam',
                    KEY_068: 'Bulgarien',
                    KEY_236: 'Burkina Faso (ehem. Obervolta)',
                    KEY_328: 'Burundi',
                    KEY_021: 'Ceuta',
                    KEY_512: 'Chile',
                    KEY_720: 'China',
                    KEY_837: 'Cook-Inseln',
                    KEY_436: 'Costa Rica',
                    KEY_272: 'Cote D\'Ivoire (Elfenbeinküste)',
                    KEY_477: 'Curacao',
                    KEY_008: 'Dänemark',
                    KEY_724: 'Dem. VR Korea (Nordkorea)',
                    KEY_322: 'Demokr. Rep. Kongo (Ehem. Zaire)',
                    KEY_460: 'Dominica',
                    KEY_456: 'Dominikanische Republik',
                    KEY_338: 'Dschibuti',
                    KEY_500: 'Ecuador',
                    KEY_096: 'Ehem. jugoslawische Rep. Mazedonien',
                    KEY_428: 'El Salvador',
                    KEY_336: 'Eritrea',
                    KEY_053: 'Estland',
                    KEY_529: 'Falklandinseln',
                    KEY_041: 'Färöer',
                    KEY_815: 'Fidschi',
                    KEY_032: 'Finnland',
                    KEY_823: 'Föderierte Staaten von Mikronesien',
                    KEY_001: 'Frankreich',
                    KEY_894: 'Französische Südgebiete',
                    KEY_822: 'Frz. Polynesien',
                    KEY_314: 'Gabun',
                    KEY_252: 'Gambia',
                    KEY_076: 'Georgien',
                    KEY_276: 'Ghana',
                    KEY_044: 'Gibraltar',
                    KEY_473: 'Grenada',
                    KEY_009: 'Griechenland',
                    KEY_406: 'Grönland',
                    KEY_831: 'Guam',
                    KEY_416: 'Guatemala',
                    KEY_107: 'Guernsey',
                    KEY_260: 'Guinea',
                    KEY_257: 'Guinea-Bissau',
                    KEY_488: 'Guyana',
                    KEY_452: 'Haiti',
                    KEY_835: 'Heard und McDonald-Inseln',
                    KEY_424: 'Honduras',
                    KEY_740: 'Hongkong',
                    KEY_664: 'Indien',
                    KEY_700: 'Indonesien',
                    KEY_109: 'Insel Man',
                    KEY_612: 'Irak',
                    KEY_007: 'Irland',
                    KEY_616: 'Islamische Republik Iran',
                    KEY_024: 'Island',
                    KEY_624: 'Israel',
                    KEY_005: 'Italien',
                    KEY_464: 'Jamaika',
                    KEY_732: 'Japan',
                    KEY_653: 'Jemen',
                    KEY_108: 'Jersey',
                    KEY_628: 'Jordanien',
                    KEY_463: 'Kaimaninseln',
                    KEY_696: 'Kambodscha',
                    KEY_302: 'Kamerun',
                    KEY_404: 'Kanada',
                    KEY_247: 'Kap Verde',
                    KEY_079: 'Kasachstan',
                    KEY_644: 'Katar',
                    KEY_346: 'Kenia',
                    KEY_083: 'Kirgisistan',
                    KEY_812: 'Kiribati',
                    KEY_833: 'Kokosinseln (Keeling-Inseln)',
                    KEY_480: 'Kolumbien',
                    KEY_375: 'Komoren',
                    KEY_095: 'Kosovo',
                    KEY_092: 'Kroatien',
                    KEY_448: 'Kuba',
                    KEY_636: 'Kuwait',
                    KEY_684: 'Laos',
                    KEY_395: 'Lesotho',
                    KEY_054: 'Lettland',
                    KEY_604: 'Libanon',
                    KEY_268: 'Liberia',
                    KEY_216: 'Libyen',
                    KEY_037: 'Liechtenstein',
                    KEY_055: 'Litauen',
                    KEY_018: 'Luxemburg',
                    KEY_743: 'Macau',
                    KEY_370: 'Madagaskar',
                    KEY_386: 'Malawi',
                    KEY_701: 'Malaysia',
                    KEY_667: 'Malediven',
                    KEY_232: 'Mali',
                    KEY_046: 'Malta',
                    KEY_204: 'Marokko',
                    KEY_824: 'Marshall-Inseln',
                    KEY_228: 'Mauretanien',
                    KEY_373: 'Mauritius',
                    KEY_377: 'Mayotte',
                    KEY_023: 'Melilla',
                    KEY_412: 'Mexiko',
                    KEY_147: 'Monaco',
                    KEY_716: 'Mongolei',
                    KEY_097: 'Montenegro',
                    KEY_470: 'Montserrat',
                    KEY_366: 'Mosambik',
                    KEY_676: 'Myanmar',
                    KEY_389: 'Namibia',
                    KEY_803: 'Nauru',
                    KEY_672: 'Nepal',
                    KEY_809: 'Neukaledonien',
                    KEY_804: 'Neuseeland',
                    KEY_814: 'Neuseeländisch-Ozeanien',
                    KEY_432: 'Nicaragua',
                    KEY_858: 'nicht ermittelte Länder und Gebiete',
                    KEY_003: 'Niederlande',
                    KEY_240: 'Niger',
                    KEY_288: 'Nigeria',
                    KEY_838: 'Niue-Insel',
                    KEY_820: 'Nördliche Marianen',
                    KEY_836: 'Norfolk-Insel',
                    KEY_028: 'Norwegen',
                    KEY_649: 'Oman',
                    KEY_038: 'Österreich',
                    KEY_662: 'Pakistan',
                    KEY_825: 'Palau',
                    KEY_442: 'Panama',
                    KEY_801: 'Papua-Neuguinea',
                    KEY_520: 'Paraguay',
                    KEY_504: 'Peru',
                    KEY_708: 'Philippinen',
                    KEY_813: 'Pitcairn',
                    KEY_890: 'Polargebiete',
                    KEY_060: 'Polen',
                    KEY_010: 'Portugal (incl. Azoren + Madeira)',
                    KEY_318: 'Republik Kongo',
                    KEY_728: 'Republik Korea (Südkorea)',
                    KEY_074: 'Republik Moldau (Moldawien)',
                    KEY_324: 'Ruanda',
                    KEY_066: 'Rumänien',
                    KEY_075: 'Russische Föderation',
                    KEY_499: 'Saba',
                    KEY_806: 'Salomonen',
                    KEY_378: 'Sambia',
                    KEY_819: 'Samoa',
                    KEY_810: 'Samoa, Amerik.',
                    KEY_047: 'San Marino',
                    KEY_311: 'Sao Tome und Principe',
                    KEY_632: 'Saudi-Arabien',
                    KEY_030: 'Schweden',
                    KEY_039: 'Schweiz',
                    KEY_248: 'Senegal',
                    KEY_098: 'Serbien',
                    KEY_094: 'Serbien und Montenegro',
                    KEY_355: 'Seychellen',
                    KEY_264: 'Sierra Leone',
                    KEY_382: 'Simbabwe',
                    KEY_706: 'Singapur',
                    KEY_498: 'Sint Eustatius',
                    KEY_479: 'Sint Maarten',
                    KEY_063: 'Slowakei',
                    KEY_091: 'Slowenien',
                    KEY_342: 'Somalia',
                    KEY_011: 'Spanien',
                    KEY_669: 'Sri Lanka',
                    KEY_329: 'St. Helena',
                    KEY_449: 'St. Kitts und Nevis',
                    KEY_465: 'St. Lucia',
                    KEY_408: 'St. Pierre und Miquelon',
                    KEY_467: 'St. Vincent und die Grenadinen',
                    KEY_388: 'Südafrika',
                    KEY_224: 'Sudan',
                    KEY_893: 'Südgeorgien u. südl. Sandwichinseln',
                    KEY_225: 'Süd-Sudan',
                    KEY_492: 'Suriname',
                    KEY_393: 'Swasiland',
                    KEY_082: 'Tadschikistan',
                    KEY_736: 'Taiwan',
                    KEY_680: 'Thailand',
                    KEY_626: 'Timor-Leste',
                    KEY_280: 'Togo',
                    KEY_839: 'Tokelau',
                    KEY_817: 'Tonga',
                    KEY_472: 'Trinidad und Tobago',
                    KEY_244: 'Tschad',
                    KEY_061: 'Tschechische Republik',
                    KEY_212: 'Tunesien',
                    KEY_052: 'Türkei',
                    KEY_080: 'Turkmenistan',
                    KEY_454: 'TurksKEY_und Caicosinseln',
                    KEY_807: 'Tuvalu',
                    KEY_350: 'Uganda',
                    KEY_072: 'Ukraine',
                    KEY_064: 'Ungarn',
                    KEY_524: 'Uruguay',
                    KEY_400: 'USA',
                    KEY_081: 'Usbekistan',
                    KEY_816: 'Vanuatu',
                    KEY_045: 'Vatikanstadt',
                    KEY_484: 'Venezuela',
                    KEY_647: 'Vereinigte Arabische Emirate',
                    KEY_352: 'Vereinigte Republik Tansania',
                    KEY_006: 'Vereinigtes Königreich',
                    KEY_690: 'Vietnam',
                    KEY_811: 'Wallis und Futuna',
                    KEY_834: 'Weihnachtsinsel (Ind. Ozean)',
                    KEY_306: 'Zentralafrikanische Republik',
                    KEY_600: 'Zypern'
                }
            },
            POSTFACHADRESSE: {
                TITEL: 'Postfachadresse',
                POSTFACH: 'Postfach',
                PLZ_ORT: 'Postleitzahl, Ort',
                PLZ: 'Postleitzahl',
                ORT: 'Ort'
            },
            GROSSEMPFAENGERADRESSE: {
                TITEL: 'Großempfängeradresse',
                PLZ_ORT: 'Postleitzahl, Ort',
                PLZ: 'Postleitzahl',
                ORT: 'Ort'
            }
        },
        KOMMUNIKATIONSMITTEL: {
            TITEL: 'Kommunikationsmittel',
            TELEFONNUMMERN_TITLE: 'Telefonnummern',
            TELEFONNUMMER: {
                VORWAHL_INT_NAT_RUF: 'Telefonnummer',
                VORWAHL_INTERNATIONAL: 'Vorwahl international',
                VORWAHL_NATIONAL: 'Vorwahl national',
                RUFNUMMER: 'Rufnummer'
            },
            ADD_TELEFONNUMMER: 'Telefonnummer erfassen',
            EMAIL: 'E-Mail-Adresse',
            INTERNET: 'Internet'
        },
        BANKVERBINDUNG: {
            KONTOINHABER: {
                NULL: 'Keine Angabe',
                LABEL: 'Kontoinhaber(in)',
                KEY_1: 'Steuerpflichtige(r)',
                KEY_2: 'Ehegatte(in)/Lebenspartner(in)',
                KEY_3: 'Steuerpflichtige(r) gemeinsam mit Ehegatte(in)/Lebenspartner(in)',
                KEY_99: 'abweichende(r) Kontoinhaber(in)',
                KAPG: {
                    KEY_1: 'steuerpflichtige Gesellschaft',
                    KEY_99: 'abweichende Person / Gesellschaft'
                }
            },
            ABWEICHENDER_KONTOINHABER: 'Abw. Kontoinhaber(in)',
            IBAN: 'IBAN',
            BIC: 'BIC'
        },
        BETRIEBSTAETTE: {
            BEZEICHNUNG: 'Bezeichnung',
            ADRESSE_TITEL: 'Adresse',
            KOMMUNIKATIONSMITTEL_TITEL: 'Kommunikationsmittel'
        },
        PERSONENSTAND: {
            PERSONENSTAND: {
                LABEL: 'Stand der Ehe / eingetragenen Lebenspartnerschaft',
                NULL: 'Keine Angabe',
                KEY_002: 'Verheiratet / Eingetragen',
                KEY_003: 'Dauernd getrennt lebend',
                KEY_004: 'Geschieden / Aufgehoben',
                KEY_005: 'Verwitwet'
            },
            GUELTIG_SEIT: 'seit dem'
        },
        PERSON: {
            GEBURTSNAME: 'Geburtsname',
            GEBURTSDATUM: 'Geburtsdatum',
            IDENTIFIKATIONSNUMMER: 'Identifikationsnummer',
            RELIGIONSSCHLUESSEL: {
                LABEL: 'Religion',
                NULL: 'Bitte wählen',
                KEY_11: 'Nicht kirchensteuerpflichtig',
                KEY_03: 'Römisch-katholisch',
                KEY_02: 'Evangelisch',
                KEY_05: 'Evangelisch-reformiert',
                KEY_20: 'Evangelisch-reformierte Kirche Bückeburg',
                KEY_21: 'Evangelisch-reformierte Kirche Stadthagen',
                KEY_07: 'Französisch-reformiert',
                KEY_16: 'Freie Religionsgemeinschaft Alzey',
                KEY_13: 'Freireligiöse Landesgemeinde Baden',
                KEY_14: 'Freireligiöse Landesgemeinde Pfalz',
                KEY_15: 'Freireligiöse Gemeinde Mainz',
                KEY_17: 'Freireligiöse Gemeinde Offenbach',
                KEY_25: 'Israelitische Religionsgemeinschaft Baden',
                KEY_19: 'Jüdische Gemeinden im Landesverband Hessen',
                KEY_26: 'Landesverband der israelitischen Kultusgemeinden in Bayern',
                KEY_18: 'Jüdische Gemeinde Frankfurt (Hessen)',
                KEY_27: 'Jüdische Kultusgemeinden Bad Kreuznach und Koblenz',
                KEY_28: 'Israelitisch (Saarland)',
                KEY_12: 'Israelitische Religionsgemeinschaft Württemberg',
                KEY_29: 'Nordrhein-Westfalen: Israelitisch (jüdisch)',
                KEY_24: 'Jüdische Gemeinde Hamburg',
                KEY_04: 'Altkatholisch',
                KEY_10: 'Sonstige'
            },
            BERUF: 'Beruf'
        },
        STEUERIDENTIFIKATION: {
            STEUERIDENTIFIKATIONSNUMMER: 'Identifikationsnummer',
            WIRTSCHAFTS_ID_NUMMER: 'Wirtschafts-Identifikationsnummer'
        },
        STEUERNUMMER: {
            STEUERNUMMER: 'Steuernummer',
            FINANZAMTNUMMER: 'Finanzamtnummer'
        },
        DATEN_UEBERNAHME: {
            TITEL: 'Welche Daten möchten Sie übernehmen?',
            PICKDATA: 'Stammdaten auswählen'
        },
        ERIC_RESPONSE: {
            TITLE: 'Folgende Fehler und Konflikte wurden gefunden:',
            INFO: 'Wir arbeiten laufend daran unsere Anwendung zu verbessern. ' +
                'Insbesondere im Bereich der Meldungen auf dieser Seite, die sich auf Ihre Eingaben beziehen, ' +
                'können wir noch besser werden und werden das Verhalten in der kommenden Zeit anpassen. ' +
                'Weitere Informationen sowie Tipps und Tricks finden Sie im Dokument',
            LINK: 'https://apps.datev.de/knowledge/help/documents/1019957',
            LINK_LABLE: '1019957'
        },
        ENTWURF_LOESCHEN: {
            TITEL: 'Fragebogen löschen',
            ENTWURF_LOESCHEN: 'Entwurf löschen',
            LOESCHEN: 'Löschen',
            ABBRECHEN: 'Abbrechen',
            MESSAGESTART: 'Wollen Sie den gewählten Fragebogen ',
            MESSAGEFOR: 'für ',
            MESSAGEEND: 'wirklich löschen?'
        },
        FRAGEBOGEN_SENDEN: {
          WEITER: 'Weiter',
          ABBRECHEN: 'Abbrechen',
          WITH_ATTACHEMENTS: {
            TITEL: 'Hinweis der Finanzverwaltung',
            CONTENT: 'Beachten Sie, dass die Finanzverwaltung die <strong>Anhänge auf schadhafte Inhalte (z.B. Viren) und aktive ' +
              'Elemente überprüft</strong>. Sollte ein Anhang bei der Prüfung als <strong>schadhaft identifiziert</strong> werden, ' +
              'wird dieser <strong>Anhang gelöscht</strong> und gelangt nicht zur Bearbeitung in das Finanzamt. In diesem Fall ' +
              'wird der Sachbearbeiter informiert und wird ggf. Kontakt mit Ihnen aufnehmen. Die Löschung des Anhangs oder die ' +
              'Entfernung aktiver Elemente hat keine Auswirkung auf das eigentliche Formular oder den Antrag/die Nachricht. ' +
              'Ausschließlich das eingereichte Formular oder der Antrag/die Nachricht sind für eine Fristwahrung relevant. ' +
              '<br/> Die vollständigen Informationen der Finanzverwaltung zum Übermitteln von Abgabedaten mit Anhang finden ' +
              'Sie im Dok-Nr. ' +
              '<a href="https://apps.datev.de/help-center/documents/9273014" target="_blank" rel="noopener noreferrer">9273014.</a> ' +
              '<br/><br/>Mit <strong>Klick auf die Schaltfläche "Weiter"</strong> bestätige ich, den oben verlinkten Hinweis der ' +
              'Finanzverwaltung vollständig gelesen zu haben. <br/><br/>Wenn Sie diesen Hinweis <strong>abbrechen</strong>, ' +
              'erfolgt keine Übermittlung an das Finanzamt.',
          },
          WITHOUT_ATTACHEMENTS: {
            TITEL: 'Daten übermitteln',
            CONTENT: 'Möchten Sie den Fragebogen <strong>jetzt</strong> an die Finanzverwaltung übermitteln?',
          },
        },
        VALIDATION: {
            INPUT_IS_TOO_LARGE_TO_HANDLE: 'Der eingegebene Wert ist zu groß und muss kleiner als {{maxValue}} sein.',
            ERIC_DECIMAL_INVALID_PATTERN: 'Der eingegebene Wert darf maximal 9 Vorkommastellen, sowie 2 Nachkommastellen enthalten.',
            ZERO_NOT_ALLOWED: 'Der eingegebene Wert muss größer als 0,00€ sein.',
            HAUSNUMMER_INVALID_PATTERN: 'Die Hausnummer darf nur Ziffern enthalten und nicht mit einer Null beginnen.',
            PLZ_INVALID_PATTERN: 'Die Postleitzahl muss eine fünfstellige Zahl sein.',
            ORT_INVALID_PATTERN: 'Der Ort darf keine Ziffern enthalten.',
            POSTFACH_INVALID_PATTERN: 'Das Postfach darf nur Ziffern enthalten.',
            VORWAHL_INT_INVALID_PATTERN: 'Die internationale Vorwahl der Telefonnummer muss mit \'00\' oder \'+\' beginnen.',
            IBAN_INVALID_PATTERN: 'Das Eingabeformat der IBAN ist nicht gültig.',
            BIC_INVALID_PATTERN: 'Das Eingabeformat der BIC ist nicht gültig.',
            DATE_IS_IN_FUTURE: 'Das eingegebene Datum darf nicht in der Zukunft liegen.',
            STEUERIDENTIFIKATIONSNUMMER_INVALID_PATTERN: 'Erfassen Sie die Identifikationsnummer als 11-stellige Ziffer.',
            WIRTSCHAFTS_ID_NUMMER_INVALID_PATTERN:
                'Erfassen Sie die Wirtschafts-Identifikationsnummer im Format DEXXXXXXXXX-XXXXX.',
            KEINE_ADRESSE_ERFASST: 'Erfassen Sie mindestens eine Inlands- oder Auslandsadresse.',
            MEHRERE_ADRESSEN_ERFASST: 'Erfassen Sie entweder eine Inlands- oder eine Auslandsadresse.',
            FINANZAMTNUMMER_INVALID_PATTERN: 'Bitte geben Sie die Finanzamtnummer vierstellig ein.',
            FINANZAMTNUMMER_VS_STEUERNUMMER_INVALID: 'Die Finanzamtnummer passt nicht zur Steuernummer.',
            STEUERNUMMER_INVALID_PATTERN: 'Bitte geben Sie die Steuernummer nach dem Standardschema der Länder ein.',
            STEUERNUMMER_VS_FINANZAMTNUMMER_INVALID: 'Die Steuernummer passt nicht zur Finanzamtnummer.',
            FINANZAMTNUMMER_MISSING: 'Die Steuernummer kann nicht ohne gültige Finanzamtnummer übermittelt werden.',
            VOLLER_POSITIVER_GELDBETRAG_PATTERN: 'Die Eingabe muss ein voller positiver Geldbetrag sein.',
            USTID_PATTERN: 'Das Eingabeformat der Umsatzsteuer-Identifikationsnummer ist nicht gültig.',
            GANZZAHL_POSITIV: 'Die Eingabe muss eine positive ganze Zahl sein.',
            ARBEITNEHMER_SUMME_VALIDE: 'Prüfen Sie die Zahl der Arbeitnehmer.',
            HANDELSREGISTER_NUMMER_INVALID_PATTERN: 'Test Die Handelsregisternummer darf nur Ziffern beinhalten.',
            GELDBETRAG_PATTERN: 'Die Eingabe muss ein voller Geldbetrag sein.',
            GESETZLICHER_VERTRETER_LENGTH: 'Bitte machen Sie Angaben zu mindestens einem gesetzlichen Vertreter.',
            ANTEILSEIGNER_HOEHE_BETEILIGUNG_NOMINELL: 'Es sind maximal 12 Stellen erlaubt.',
            ANTEILSEIGNER_HOEHE_BETEILIGUNG_PROZENT: 'Format ungültig: Der Wert muss zwischen 0,0001 und 100.0000 liegen.',
            EINGEZAHLTES_GRUNDKAPITAL_HOEHE: 'Die Höhe des eingezahlten Kapitals darf das Grundstammkapitals nicht übersteigen.',
            UST_IDENTIFIKATION_NUMMER: 'Das Eingabeformat der Umsatzsteuer-Identifikationsnummer ist nicht gültig.'
        },
        FINANZAMT: {
            BUNDESLAND: {
                LABEL: 'Bundesland',
                NULL: 'Bitte wählen',
                NUMBER_28: 'Baden-Württemberg',
                NUMBER_9: 'Bayern',
                NUMBER_11: 'Berlin',
                NUMBER_30: 'Brandenburg',
                NUMBER_24: 'Bremen',
                NUMBER_22: 'Hamburg',
                NUMBER_26: 'Hessen',
                NUMBER_40: 'Mecklenburg-Vorpommern',
                NUMBER_23: 'Niedersachsen',
                NUMBER_5: 'Nordrhein-Westfalen',
                NUMBER_27: 'Rheinland-Pfalz',
                NUMBER_10: 'Saarland',
                NUMBER_32: 'Sachsen',
                NUMBER_31: 'Sachsen-Anhalt',
                NUMBER_21: 'Schleswig-Holstein',
                NUMBER_41: 'Thüringen'
            },
            FINANZAMTNUMMER: {
                LABEL: 'Finanzamt',
                NULL: 'Bitte wählen'
            }
        },
        FRAGEBOGEN: {
            MAX_LIMIT_HINT: 'Es wurden mehr Stammdatensätze gefunden als über die Schnittstelle zur Finanzverwaltung übermittelt werden ' +
                'können. Bitte prüfen Sie daher die vorbelegten Eingaben und löschen Sie bei Bedarf einen Datensatz.',
            ANTRAGSTELLER: {
                FORMULAR_TITEL: 'Angaben zur Person'
            },
            STEUERIDENTIFIKATION: {
                STEUERIDENTIFIKATION_TITEL: 'Steueridentifikation'
            },
            FINANZAMT: {
                TITEL: 'Angaben zum Finanzamt',
                HINWEIS: 'Bitte wählen Sie das Finanzamt, an das der Fragebogen übermittelt werden soll.',
                STAMMDATEN_UEBERNAHME_FINANZAMT: 'Finanzamt',
                STAMMDATEN_UEBERNAHME_STEUERNUMMER: 'aus Steuernummer'
            },
            ABWEICHENDERORTGESCHAEFTSLEITUNG: {
                TITEL: 'Abweichender Ort der Geschäftsleitung',
                ENTSPRICHT: 'Der abweichende Ort der Geschäftsleitung befindet sich an der Wohnanschrift des Steuerpflichtigen.',
                ERFASSEN: 'Der Ort der Geschäftsleitung weicht von der Unternehmensadresse ab.',
                ENTSPRICHTWOHNANSCHRIFT: 'Der abweichende Ort der Geschäftsleitung befindet sich an der Wohnanschrift ' +
                    'des Steuerpflichtigen.',
                ADRESSE_TITEL: 'Adresse',
                KOMMUNIKATIONSMITTEL_TITEL: 'Kommunikationsmittel'
            },
            BANKVERBINDUNGEN: {
                TITEL: 'Bankverbindung(en) für Steuererstattungen / SEPA-Lastschriftverfahren',
                PERSONENSTEUERN_TITEL: 'Personensteuererstattungen',
                BETRIEBSSTEUERN_TITEL: 'Betriebssteuererstattungen',
                BETRIEBSSTEUERN_WIE_PERSONENSTEUERN: 'Gleiche Bankverbindung wie bei Personensteuererstattungen',
                HINWEIS: 'Alle Steuererstattungen sollen auf folgende Bankverbindung erfolgen. ' +
                    'Sofern die Teilnahme am SEPA-Lastschriftverfahren erwünscht ist, reichen ' +
                    'Sie bitte eine entsprechende Vollmacht nach.',
                INFO: 'Bitte das ausgefüllte SEPA-Lastschriftmandat gesondert übermitteln.'
            },
            BETRIEBSTAETTEN: {
                TITEL: 'Betriebsstätten',
                ADD_BETRIEBSTAETTE: 'Betriebsstätte hinzufügen',
                NEUE_BETRIEBSTAETTE: 'Neue Betriebsstätte',
                REMOVE_BETRIEBSTAETTE: 'Betriebsstätte löschen'
            },
            STEUERLICHEBERATUNG: {
                TITEL: 'Steuerliche Beratung',
                PERSONENTYP_TITEL: 'erfolgt durch',
                PERSONENTYP: {
                    NULL: 'Keine Angabe',
                    BITTE_WAEHLEN: 'Bitte wählen',
                    KEY_NATPERS: 'Natürliche Person',
                    KEY_NNATPERS: 'Nicht natürliche Person'
                },
                VOLLMACHT_TITEL: 'Vollmacht',
                INFO: 'Die Vollmacht ist einzureichen oder über die Vollmachtsdatenbank (§ 80a AO) anzuzeigen.',
                ANZEIGE_UEBER_VOLLMACHTSDATENBANK: 'Die Anzeige der Vollmacht erfolgt über die Vollmachtdatenbank (§ 80a AO).'
            },
            EMPFANGSBEVOLLMAECHTIGUNG: {
                TITEL: 'Empfangsbevollmächtigte(r) für alle Steuerarten',
                INFO: 'Die Empfangsvollmacht ist einzureichen oder über die Vollmachtsdatenbank (§ 80a AO) anzuzeigen.',
                LEER_STEUERBERATER: 'Es wurde angegeben, dass die steuerliche Beratung empfangsbevollmächtigt ist. ' +
                    'Bitte machen Sie auch Angaben zur steuerlichen Beratung.',
                PERSONENTYP_TITEL: 'Bevollmächtigte(r)',
                PERSONENTYP: {
                    NULL: 'Keine Angabe',
                    KEY_NATPERS: 'Natürliche Person',
                    KEY_NNATPERS: 'Nicht natürliche Person'
                },
                VOLLMACHT_TITEL: 'Empfangsvollmacht',
                ANZEIGE_UEBER_VOLLMACHTSDATENBANK: 'Die Anzeige der Empfangsvollmacht erfolgt ' +
                    'über die Vollmachtdatenbank (§ 80a AO).',
                STEUERBERATER_VOLLMACHT: 'Empfangsvollmacht vom Steuerberater liegt vor.',
                TITEL_MERKERPARAGRAPH183: 'Empfangsvollmacht',
                GEMEIN_EMPF_BEV: {
                    TITEL: 'Nur bei nicht rechtsfähigen Personenvereinigungen',
                    UNTERTITEL: 'Gemeinsame(r) von allen Gesellschaften/Gemeinschaftern ' +
                        'bestellte(r) Empfangsbevollmächtigte(r) nach § 183a Absatz 1 ' +
                        'Satz 1 AO bei der gesonderten und einheitlichen Feststellung',
                    LABEL: 'Gemeinsamer Empfangsbevollmächtigte(r) ist',
                    NULL: 'Keine Angabe',
                    KEY_1: 'die Vertretung der Gesellschaft/Gemeinschaft',
                    KEY_2: 'die steuerliche Beratung der Gesellschaft/Gemeinschaft'
                },
            },
            ADRESSE: {
                ADRESSE_TITEL: 'Adresse',
                ADRESSE_GESELLSCHAFT: 'Anschrift der Gesellschaft'
            },
            KOMMUNIKATIONSMITTEL: {
                KOMMUNIKATIONSMITTEL_TITEL: 'Kommunikationsmittel'
            },
            ANTRAG_VERSENDEN: {
                FINANZAMT_FEHLT: 'Bitte wählen Sie das zuständige Finanzamt aus.',
                TITEL: 'Fragebogen prüfen und versenden',
                VERSANDBEREIT: 'Die Plausibilitätsprüfung Ihrer Angaben war erfolgreich und der Fragebogen ' +
                    'kann an die Finanzverwaltung versendet werden.',
                VERSENDEN: 'Fragebogen versenden',
                VORSCHAU: 'Vorschau öffnen',
                WIRD_VERSENDET: 'Ihr Fragebogen wird an die Finanzverwaltung übermittelt...',
                ZUR_UEBERSICHT: 'Zur Übersicht',
                UEBERMITTLUNGSDETAILS: 'Details zur Übermittlung finden Sie in der Vorschau.',
                ERFOLGREICHE_UEBERMITTLUNG: {
                    TEXT_1: 'Der Fragebogen wurde am ',
                    TEXT_2: ' um ',
                    TEXT_3: ' Uhr erfolgreich an die Finanzverwaltung übermittelt.'
                },
                FEHLERHAFTE_UEBERMITTLUNG: {
                    TEXT_1: 'Der Fragebogen konnte nicht übermittelt werden.',
                    TEXT_2: 'Bitte versuchen Sie den Fragebogen erneut zu versenden.'
                },
                STATUS: {
                    STATUS: 'Status',
                    SUCCESSFUL: 'bei Finanzverwaltung eingegangen',
                    FINALIZED: 'bei Finanzverwaltung eingegangen',
                    SENDING: 'wird an Finanzverwaltung übermittelt',
                    CONFIRMED: 'wird an Finanzverwaltung übermittelt',
                    ELSTER_TRANSFER_ID: 'ELSTER-Transfer-ID',
                    TRANSFER_DATE: 'Eingang Finanzverwaltung',
                    TRANSFERRED_BY: 'Übermittler'
                }
            },
            TAETIGKEIT_ANGABEN: {
                TAETIGKEITART: 'Art der Tätigkeit (genaue Bezeichnung des Gewerbezweiges)',
                BEZEICHNUNG: 'Bezeichnung des Unternehmens',
                TAETIGKEITBEGINN: 'Beginn der Tätigkeit (inkl. Vorbereitungshandlungen)'
            },
            ONESTOPSHOP: {
                TITEL: 'Besonderes Besteuerungsverfahren "One-stop-shop"',
                HINWEIS_DOPPELTEANGABE: 'Wählen Sie nur eine Angabe aus.',
                INLAND: {
                    TITEL: 'Für im Inland ansässige Unternehmer',
                    HINWEIS: 'Nur bei Ausführung von Lieferungen innerhalb eines Mitgliedstaates durch ' +
                        'Betreiber elektronischer Schnittstellen (§ 3 Absatz 3a Satz 1 UStG), ' +
                        'innergemeinschaftlichen Fernverkäufen (§ 3c Absatz 1 Sätze 2 und 3 UStG) ' +
                        'und sonstigen Leistungen an Nichtunternehmer, die in einem anderen ' +
                        'EU-Mitgliedsstaat ansässig sind. \n Die Teilnahme am besonderen ' +
                        'Besteuerungsverfahren muss gesondert beim BZSt angezeigt werden. ' +
                        'Die folgenden Angaben ersetzen deshalb nicht diese Anzeigeverpflichtung.',
                    ANSAESSIGKEITSSTAAT: 'Das besondere Besteuerungsverfahren ("One-stop-shop") ' +
                        'wird in Anspruch genommen (§ 18j UStG). Die entsprechenden Umsätze wird die ' +
                        'Gesellschaft beim BZSt erklären.',
                    KEINENL: 'Es existiert keine Niederlassung in einem anderen EU-Mitgliedsstaat ' +
                        'und der Gesamtbetrag - ohne Umsatzsteuer - der innergemeinschaftlichen Fernverkäufe ' +
                        '(§ 3c Absatz 1 Sätze 2 und 3 UStG) und Telekommunikationsdienstleistungen, ' +
                        'Rundfunk- und Fernsehdienstleistungen oder auf elektronischem Weg ' +
                        'erbrachten sonstigen Leistungen an in anderen EU-Mitgliedstaaten ansässige ' +
                        'Nichtunternehmer überschreitet im laufenden Kalenderjahr nicht 10.000 Euro und hat dies ' +
                        'auch im vorangegangenen Kalenderjahr nicht getan.',
                    VERSTEUERUNG: 'Die entsprechenden Umsätze werden im Inland ' +
                        '(§ 3a Absatz 5 Satz 3 und § 3c Absatz 4 Satz 1 UStG) versteuert.',
                    VERZICHT: 'Auf die Möglichkeit der Versteuerung der entsprechenden Umsätze im ' +
                        'Inland wird für mindestens zwei Kalenderjahre ' +
                        'verzichtet (§ 3a Absatz 5 Sätze 4 und 5 sowie § 3c Absatz 4 Sätze 2 und 3 UStG).',
                    VERZICHT_BZST: 'Es wird das besondere Besteuerungsverfahren ("One-stop-shop") ' +
                        'in Anspruch genommen (§ 18j UStG). Die entsprechenden Umsätze werden beim BZSt erklärt.',
                    VERZICHT_EU: 'Die entsprechenden Umsätze werden direkt in den anderen EU-Mitgliedstaaten erklärt.'
                },
                AUSLAND: {
                    TITEL: 'Für in einem anderen EU-Mitgliedsstaat ansässige Unternehmer',
                    HINWEIS: 'Nur bei Ausführung von Lieferungen innerhalb eines Mitgliedstaates ' +
                        'durch Betreiber elektronischer Schnittstellen (§ 3 Absatz 3a Satz 1 UStG), ' +
                        'innergemeinschaftlichen Fernverkäufen (§ 3c Absatz 1 Sätze 2 und 3 UStG) ' +
                        'und sonstigen Leistungen an einen in Deutschland ansässigen Nichtunternehmer.',
                    ANSAESSIGKEITSSTAAT: 'Das besondere Besteuerungsverfahren ("One-stop-shop") ' +
                        'wird in Anspruch genommen (§ 18j UStG). Die entsprechenden Umsätze werden ' +
                        'beim Bundeszentralamt für Steuern (BZSt) erklärt.',
                    KEINENL: 'Ansässigkeit besteht nur in einem EU-Mitgliedsstaat und der Gesamtbetrag - ohne Umsatzsteuer - der ' +
                        'innergemeinschaftlichen Fernverkäufe (§ 3c Absatz 1 Sätze 2 und 3 UStG) und Telekommunikationsdienstleistungen, ' +
                        'Rundfunk- und Fernsehdienstleistungen oder auf elektronischem Weg erbrachten sonstigen Leistungen an in anderen ' +
                        'EU-Mitgliedstaaten außerhalb des Ansässigkeitsstaates ansässige Nichtunternehmer überschreitet im laufenden ' +
                        'Kalenderjahr nicht 10.000 Euro und hat dies auch im vorangegangenen Kalenderjahr nicht getan.',
                    VERSTEUERUNG: 'Die entsprechenden Umsätze werden im Ansässigkeitsstaat versteuert.',
                    VERZICHT: 'Auf die Möglichkeit der Versteuerung der entsprechenden Umsätze im Ansässigkeitsstaat wird für ' +
                        'mindestens zwei Kalenderjahre verzichtet.',
                    VERZICHT_EU: 'Das besondere Besteuerungsverfahren ("One-stop-shop") wird in Anspruch genommen (§ 18j UStG). ' +
                        'Die entsprechenden Umsätze werden über die zuständige Behörde im Ansässigkeitsstaat erklärt.',
                    VERZICHT_DE: 'Die entsprechenden Umsätze werden direkt in Deutschland erklärt.'
                }
            },
            FREISTELLUNGSBESCHEINIGUNG: {
                TITEL: 'Freistellungsbescheinigung gemäß § 48b EStG (Bauabzugssteuer)',
                HINWEIS: 'Das Merkblatt zum Steuerabzug bei Bauleistungen steht Ihnen im Internet unter ' +
                    '<a href="http://www.bzst.de" target="_blank" rel="noopener noreferrer">www.bzst.de</a> ' +
                    'zum Download zur Verfügung. Sie können es aber auch bei Ihrem Finanzamt erhalten.',
                ANTRAGGESTELLT: 'Die Erteilung einer Bescheinigung zur Freistellung vom Steuerabzug bei ' +
                    'Bauleistungen gemäß § 48b EStG wird beantragt.'
            },
            UMSAETZE_INTERNET: {
                TITEL: 'Umsätze im Bereich des Handels mit Waren über das Internet',
                EIGENER_WEBSHOP: 'Es wird über einen eigenen Webshop verkauft.',
                EIGENER_WEBSHOP_URL: 'Web-Adresse (URL)',
                HANDEL_MARKTPLATZ: 'Es wird über eine/mehrere elektronische Schnittstelle(n) im Sinne ' +
                    'des § 25e Absatz 5 UStG gehandelt. Eine elektronische Schnittstelle im Sinne ' +
                    'des § 25e Absatz 5 UStG ist ein elektronischer Marktplatz, eine elektronische ' +
                    'Plattform, ein elektronisches Portal oder Ähnliches.',
                ADD_MARKTPLATZ: 'Schnittstelle hinzufügen',
                REMOVE_MARKTPLATZ: 'Marktplatz löschen',
                NEUER_MARKTPLATZ: 'Neuer Marktplatz',
                MARKTPLAETZE: {
                    TITEL: 'Elektronische Schnittstelle',
                    BEZEICHNUNG: 'Name der elektronischen Schnittstelle',
                    IDENTIFIKATIONSMERKMAL: 'Identifikationsmerkmal (z.B. Accountname)'
                }
            },
            INFLUENCER: {
              TITEL: 'Influencer',
              UMSAETZE_UEBER_PLATTFORM: 'Ich erziele über eine/mehrere Plattformen der Sozialen Medien Umsätze.',
              ADD_PLATTFORM: 'Eintrag hinzufügen',
              REMOVE_PLATTFORM: 'Plattform löschen',
              PLATTFORMEN: {
                  NAME: 'Name der Plattform',
                  ACCOUNT_NAME: 'Accountname'
              }
            },
            HANDELSREGISTEREINTRAG: {
                TITEL: 'Handelsregistereintrag',
                ISTERFOLGT: {
                    TITEL: 'Handelsregistereintragung ist erfolgt',
                    NULL: 'Keine Angabe',
                    JA: 'Ja',
                    NEIN: 'Nein'
                },
                ISTBEABSICHTIGT: {
                    TITEL: 'Eine Eintragung ist beabsichtigt',
                    NULL: 'Keine Angabe',
                    JA: 'Ja',
                    NEIN: 'Nein'
                },
                BEREITSGESTELLT: {
                    TITEL: 'Antrag beim Handelsregister wurde gestellt',
                    NULL: 'Keine Angabe',
                    JA: 'Ja',
                    NEIN: 'Nein'
                },
                STAMMDATEN_LABEL: 'Angaben zum Gesellschaftsvertrag / Handelsregistereintrag',
                HANDELSREGISTERNUMMER_LABEL: 'Handelsregisternummer',
                HANDELSREGISTERBEZEICHNUNG_LABEL: 'Handelsregister Bezeichnung',
                EINGETRAGENAM_LABEL: 'Eingetragen am',
                ORTREGISTERGERICHT: 'Ort des Amtsgerichts',
                ORTREGISTERGERICHT_LABEL: 'Registergericht',
                GESTELLTAM: 'Antrag wurde gestellt am',
                EINGETRAGENAM: 'Der Handelsregistereintrag besteht seit',
                BEZEICHNUNG: {
                    TITEL: 'Register',
                    NULL: 'Bitte wählen',
                    KEY_HRA: 'HRA [Handelsregister A]',
                    KEY_HRB: 'HRB [Handelsregister B]',
                    KEY_GSR: 'GsR [Gesellschaftsregister]',
                    KEY_PR: 'PR [Partnerschaftsregister]',
                    KEY_GNR: 'GnR [Genossenschaftsregister]',
                    KEY_VR: 'VR [Vereinsregister]'
                },
                NUMMER: 'Registernummer'
            },
            UMSATZSTEUER: {
                TITEL: 'Angaben zur Anmeldung und Abführung der Umsatzsteuer',
                ZAHLLAST: {
                    TITEL: 'Zahllast / Überschuss (geschätzt)',
                    AUSWAHL_LABEL: 'Voraussichtliche Umsatzsteuer',
                    NULL_VALUE: 'Keine Angabe',
                    KEY_1: 'Zahllast (geschätzt)',
                    KEY_2: 'Überschuss (geschätzt)',
                    BETRAG_LABEL: 'Betrag',
                    VORANMELDUNGMONATLICH_LABEL: 'An Stelle des Kalendervierteljahres wird der ' +
                        'Kalendermonat als Voranmeldungszeitraum gewählt, weil für das laufende Kalenderjahr ' +
                        'der Überschuss die Grenzen des § 18 Absatz 2a Satz 1 in Verbindung mit Absatz 2 Satz 6 ' +
                        'UStG voraussichtlich übersteigt.'
                },
                SUMME_UMSAETZE: {
                    TITEL: 'Summe der Umsätze (geschätzt)',
                    BETREROEFFNUNG: 'im Jahr der Betriebseröffnung',
                    FOLGEJAHR: 'im Folgejahr'
                },
                GESCHAEFTSVERAEUSSERUNG: {
                    TITEL: 'Geschäftsveräußerung im Ganzen (§ 1 Abs. 1a UStG)',
                    LABEL: 'Es wurde ein Unternehmen oder ein in der Gliederung eines Unternehmens gesondert geführter Betrieb erworben',
                    NULL_VALUE: 'Keine Angabe',
                    TRUE_VALUE: 'Ja',
                    FALSE_VALUE: 'Nein',
                    ARTUNTERNEHMEN: 'Art des Unternehmens',
                    BEZGESELLSHAFT: 'Bezeichnung des Unternehmens'
                },
                KLEINUNTERNEHMER: {
                    TITEL: 'Kleinunternehmer-Regelung (§ 19 UStG)',
                    SUBTITEL: 'Die Umsätze unterliegen bis zur Überschreitung des Betrages des § 19 Absatz 1 in Verbindung ' +
                        'mit § 19 Absatz 2 UStG der Kleinunternehmer-Regelung nach § 19 UStG. Bis zur Überschreitung ' +
                        'des Betrages wird in Rechnungen keine Umsatzsteuer gesondert ausgewiesen und kein Vorsteuerabzug ' +
                        'geltend gemacht. Angaben zur Soll-/Istversteuerung der Entgelte sind nicht erforderlich.',
                    LABEL: 'Die Kleinunternehmer-Regelung wird',
                    NULL_VALUE: 'Keine Angabe',
                    TRUE_VALUE: 'in Anspruch genommen',
                    FALSE_VALUE: 'nicht in Anspruch genommen',
                    HINWEIS_TRUE: 'In Rechnungen wird keine Umsatzsteuer gesondert ausgewiesen und es ' +
                        'kann kein Vorsteuerabzug geltend gemacht werden. Angaben zur Soll-/Istversteuerung ' +
                        'der Entgelte sind nicht erforderlich; Umsatzsteuer-Voranmeldungen sind ' +
                        'grundsätzlich nicht zu übermitteln.',
                    HINWEIS_FALSE: 'Es wird auf die Anwendung der Kleinunternehmer-Regelung verzichtet. ' +
                        'Die Besteuerung erfolgt nach den allgemeinen Vorschriften des Umsatzsteuergesetzes für mindestens ' +
                        'fünf Kalenderjahre (§ 19 Absatz 3 UStG); Umsatzsteuer-Voranmeldungen sind in ' +
                        'elektronischer Form authentifiziert zu übermitteln. ' +
                        'Sofern das Unternehmen nicht im Inland ansässig ist, hat die Erklärung des ' +
                        'Verzichts gegenüber der zuständigen Finanzbehörde im Mitgliedstaat der Ansässigkeit zu erfolgen.',
                    HINWEIS: 'Die Summe der geschätzten Umsätze im Jahr der Betriebseröffnung wird abhängig vom Gründungsdatum ' +
                        'auf das gesamte Jahr hochgerechnet.'
                },
                BISHERIGEVERHAELTNISSE: {
                    TITEL: 'Bisherige umsatzsteuerliche Verhältnisse',
                    SUBTITEL: 'Ich werde aktuell bei einem Finanzamt umsatzsteuerlich geführt',
                    LABEL: 'Steuernummer',
                    NULL_VALUE: 'Keine Angabe',
                    TRUE_VALUE: 'Ja',
                    FALSE_VALUE: 'Nein'
                },
                STEUERBEFREIUNG: {
                    TITEL: 'Steuerbefreiung',
                    LABEL: 'Es werden ganz oder teilweise steuerfreie Umsätze gemäß § 4 UStG ausgeführt',
                    NULL_VALUE: 'Keine Angabe',
                    TRUE_VALUE: 'Ja',
                    FALSE_VALUE: 'Nein',
                    NUMMER: 'Tragen Sie die Nummer aus § 4 UStG ein',
                    ART: 'Art des Umsatzes / der Tätigkeit'
                },
                STEUERSATZ: {
                    TITEL: 'Steuersatz',
                    USTG2:{
                      LABEL: 'Es werden Umsätze ausgeführt, die ganz oder teilweise dem ermäßigten ' +
                        'Steuersatz gemäß § 12 Abs. 2 UStG unterliegen',
                      NULL_VALUE: 'Keine Angabe',
                      TRUE_VALUE: 'Ja',
                      FALSE_VALUE: 'Nein',
                      NUMMER: 'Tragen Sie die Nummer aus § 12 Absatz 2 UStG ein',
                      ART: 'Art des Umsatzes / der Tätigkeit'
                    },
                    USTG3:{
                      LABEL: 'Es werden Umsätze ausgeführt, die ganz oder teilweise dem ermäßigten ' +
                        'Steuersatz gemäß § 12 Abs. 3 UStG (sogenannter Nullsteuersatz) unterliegen',
                      NULL_VALUE: 'Keine Angabe',
                      TRUE_VALUE: 'Ja',
                      FALSE_VALUE: 'Nein',
                      NUMMER: 'Steuerermäßigung nach § 12 Absatz 2 Nummer ... UStG',
                      ART: 'Art des Umsatzes / der Tätigkeit',
                      USTG_1: 'gem. § 12 Abs. 3 Nummer 1 UStG',
                      USTG_2: 'gem. § 12 Abs. 3 Nummer 2 UStG',
                      USTG_3: 'gem. § 12 Abs. 3 Nummer 3 UStG',
                      USTG_4: 'gem. § 12 Abs. 3 Nummer 4 UStG',
                    }
                },
                DURCHSCHNITTSSATZBESTEUERUNG: {
                    TITEL: 'Durchschnittssatzbesteuerung',
                    LABEL: 'Im Rahmen eines land- und forstwirtschaftlichen Betriebs werden Umsätze im ' +
                      'Sinne des § 24 Absatz 1 UStG ausgeführt',
                    NULL_VALUE: 'Keine Angabe',
                    NUMMER_NULL_VALUE: 'Bitte wählen',
                    TRUE_VALUE: 'Ja',
                    FALSE_VALUE: 'Nein',
                    NUMMER: 'Tragen Sie die Nummer aus § 24 Absatz 1 UStG ein',
                    ART: 'Art des Umsatzes / der Tätigkeit',
                    WARNING: 'Es wurde angegeben, dass die Umsätze der Durchschnittsbesteuerung gemäß § 24 ' +
                        'UStG unterliegen, daher dürfen keine Angaben zur Kleinunternehmer-Regelung gemacht werden.',
                  VERZICHT: 'Es wird auf die Anwendung der Durchschnittssatzbesteuerung verzichtet. ' +
                    'Die Besteuerung erfolgt nach den allgemeinen Vorschriften des Umsatzsteuergesetzes ' +
                    'für mindestens fünf Kalenderjahre (§24 Absatz 4 UStG).',
                  ANSPRUCH: 'Es wird die Durchschnittssatzbesteuerung in Anspruch genommen.'
                },
                SOLLISTVERSTEUERUNG: {
                    TITEL: 'Soll- / Istversteuerung der Entgelte',
                    LABEL: 'Die Umsatzsteuer wird berechnet nach',
                    NULL_VALUE: 'Keine Angabe',
                    KEY_SOLLVERSTEUERUNG: 'Sollversteuerung',
                    KEY_ISTVERSTEUERUNG: 'Istversteuerung',
                    ISTGESAMTUMSATZ: 'Es wird die Istversteuerung beantragt, weil der auf das ' +
                        'Kalenderjahr hochgerechnete Gesamtumsatz für das Gründungsjahr den ' +
                        'in § 20 Satz 1 Nummer 1 UStG genannten Betrag voraussichtlich nicht übersteigen wird.',
                    ISTBEFREIUNG: 'Die Istversteuerung wird beantragt, weil eine Befreiung von der ' +
                        'Verpflichtung, Bücher zu führen und auf Grund jährlicher Bestandsaufnahmen ' +
                        'regelmäßig Abschlüsse zu machen, nach § 148 Abgabenordnung (AO) vorliegt.',
                    ISTFREIERBERUF: 'Die Istversteuerung wird beantragt, weil Umsätze ausgeführt werden, ' +
                        'für die man als Angehöriger eines freien Berufs im Sinne von § 18 Abs. ' +
                        '1 Nummer 1 des Einkommensteuergesetzes weder ' +
                        'buchführungspflichtig ist noch freiwillig Bücher geführt werden müssen.',
                    HINWEIS_ISTVERSTEUERUNG: 'Wählen Sie mindestens einen Grund für die Beantragung der Istversteuerung aus.'
                },
                USTID: {
                    TITEL: 'Umsatzsteuer-Identifikationsnummer',
                    JURISTISCHE_PERSON: 'Zusatzangaben für juristische Person',
                    JURISTISCHE_PERSON_HINWEIS: 'Zusatzangaben für juristische Personen,\n - ' +
                    'die nicht Unternehmer sind,\n - die Gegenstände nicht ' +
                    'für ihr Unternehmen erwerben.',
                    BENOETIGT: 'Ich benötige eine Umsatzsteuer-Identifikationsnummer für die Teilnahme am ' +
                        'innergemeinschaftlichen Waren- und Dienstleistungsverkehr und/oder den Handel mit ' +
                        'Waren über das Internet über eine/mehrere elektronische Schnittstelle(n) im ' +
                        'Sinne des § 25e Absatz 5 UStG.',
                    BENOETIGT_ALT_TEXT: 'Es wird eine Umsatzsteuer-Identifikationsnummer benötigt für die Teilnahme am ' +
                        'innergemeinschaftlichen Waren- und Dienstleistungsverkehr und/oder für den Handel mit Waren über ' +
                        'das Internet über eine/mehrere elektronische Schnittstelle(n) im Sinne des § 25e Absatz 5 UStG.',
                    VORHANDEN: 'Eine USt-IdNr. ist bereits aus einer früheren Tätigkeit vorhanden.',
                    VORHANDEN_ID: 'Es wurde bereits für eine frühere Tätigkeit folgende Umsatzsteuer-Identifikationsnummer vergeben',
                    VORHANDEN_VERGABEDATUM: 'Vergabedatum',
                    BENOETIGT_GRUND: 'Es wird eine Umsatzsteuer-Identifikationsnummer beantragt weil:',
                    KEINE_ANGABE: 'Keine Angabe',
                    GRUND_NULL: 'Keine Angabe',
                    GRUND_ERWRBEU: 'innergemeinschaftliche Erwerbe zu versteuern sind, da die Erwerbsschwelle von ' +
                        '12.500 € jährlich voraussichtlich überschritten wird (§ 1a Absatz 3 UStG).',
                    GRUND_VERZSCHW: 'innergemeinschaftliche Erwerbe zu versteuern sind, da die Erwerbsschwelle von ' +
                        '12.500 € jährlich zwar voraussichtlich nicht überschritten wird, jedoch auf die ' +
                        'Erwerbsschwellenregelung für die Dauer von mindestens zwei Kalenderjahren ' +
                        'verzichtet wird (§ 1a Absatz 4 UStG).',
                    GRUND_NEUKFZ: 'neue Fahrzeuge oder bestimmte verbrauchsteuerpflichtige Waren ' +
                      'innergemeinschaftlich erworben werden (§ 1a Absatz 5 UStG).',
                },
                STEUERSCHULDNERSCHAFT: {
                    TITEL: 'Steuerschuldnerschaft des Leistungsempfängers bei Bau- und/oder Gebäudereinigungsleistungen',
                    HINWEIS: 'Die Voraussetzungen zur Erteilung der Bescheinigung sind in geeigneter Weise glaubhaft zu ' +
                        'machen und gesondert zu übermitteln.',
                    HINWEIS_KEINE_ANGABE: 'Es wurde die Erteilung eines Nachweises zur Steuerschuldnerschaft des Leistungsempfängers ' +
                        'bei Bau- und / oder Gebäudereinigungsleistungen beantragt, jedoch keine Angabe zum Umfang der Bau- und / oder ' +
                        'Gebäudereinigungsleistungen gemacht.',
                    BEANTRAGT: 'Es wird die Erteilung eines Nachweises zur Steuerschuldnerschaft ' +
                        'des Leistungsempfängers bei Bau- und/oder ' +
                        'Gebäudereinigungsleistungen (Vordruck USt 1 TG) beantragt.',
                    BEANTRAGT_BAU: 'Der Umfang der ausgeführten Bauleistungen im Sinne des § 13b Abs. ' +
                        '2 Nummer 4 UStG beträgt voraussichtlich ' +
                        'mehr als 10 Prozent des Weltumsatzes (Summe der im Inland steuerbaren und nicht steuerbaren Umsätze).',
                    BEANTRAGT_GEBAEUDE: 'Der Umfang der ausgeführten Gebäudereinigungsleistungen ' +
                        'im Sinne des § 13b Abs. 2 Nummer 8 UStG beträgt ' +
                        'voraussichtlich mehr als 10 Prozent des Weltumsatzes ' +
                        '(Summe der im Inland steuerbaren und nicht steuerbaren Umsätze).'
                },
                VERGUETUNG_VON_VORSTEUER: {
                    TITEL: 'Vergütung von Vorsteuer',
                    FUER_DAS_UNTERNEHMEN: 'Für das Unternehmen wurden in der Vergangenheit bereits Anträge auf Vergütung ' +
                        'von Vorsteuerbeträgen gestellt.',
                    NULL_VALUE: 'Keine Angabe',
                    TRUE_VALUE: 'Ja',
                    FALSE_VALUE: 'Nein',
                    ZEITRAUM_VOM: 'Zeitraum vom',
                    ZEITRAUM_BIS: 'Zeitraum bis',
                    AKTENZEICHEN: 'Aktenzeichen'
                },
                EORI_NUMMER: {
                    TITEL: 'EORI-Nummer',
                    INFO: 'Es handelt sich hier um die "Economic Operators Registration and Identification number", die Nummer zur ' +
                        'Registrierung und Identifizierung von Wirtschaftsbeteiligten.',
                    LABEL: 'EORI-Nummer, soweit erteilt:'
                }
            },
            ORGANSCHAFT: {
                TITEL: 'Umsatzsteuerliche Organschaft (§ 2 Abs. 2 Nummer 2 UStG)',
                TEXT: 'Der/Die Antragsteller(in) ist Organträger folgender Organgesellschaften',
                ADD_ORGANSCHAFT: 'Organgesellschaft hinzufügen',
                NEUE_ORGANSCHAFT: 'Neue Organgesellschaft',
                REMOVE_ORGANSCHAFT: 'Organgesellschaft löschen',
                ORGANGESELLSCHAFT: {
                    BEZEICHNUNG: 'Firmenbezeichnung',
                    RECHTSFORM: {
                        LABEL: 'Rechtsform',
                        NULL: 'Keine Angabe',
                        KEY_310: 'Aktiengesellschaft',
                        KEY_270: 'Gesellschaft des bürgerlichen Rechts',
                        KEY_350: 'Gesellschaft mit beschränkter Haftung',
                        KEY_230: 'GmbH und Co. KG',
                        KEY_220: 'Kommanditgesellschaft',
                        KEY_320: 'Kommanditgesellschaft auf Aktien',
                        KEY_210: 'Offene Handelsgesellschaft',
                        KEY_991: 'Sonstige'
                    },
                    ADRESSE_TITEL: 'Adresse',
                    BETEILIGUNGSVERHAELTNIS: {
                        TITEL: 'Beteiligungsverhältnis (Bruchteil)',
                        ZAEHLER_NENNER: 'Zähler / Nenner',
                        ZAEHLER: 'Zähler',
                        NENNER: 'Nenner',
                        USTID: 'Umsatzsteuer-Identifikationsnummer'
                    },
                    STEUERNUMMER_TITEL: 'Steuernummer',
                    VALIDATION: {
                        BETEILIGUNGSVERHAELTNIS_ZAEHLER: 'Der Zähler darf nur Ziffern enthalten und nicht mit einer Null beginnen.',
                        BETEILIGUNGSVERHAELTNIS_NENNER: 'Der Nenner darf nur Ziffern enthalten und nicht mit einer Null beginnen.',
                        USTID_PATTERN: 'Das Eingabeformat der Umsatzsteuer-Identifikationsnummer ist nicht gültig.',
                        ZAEHLER_GROESSER_NENNER: 'Der Zähler darf nicht größer als der Nenner sein.'
                    }
                }
            },
            GEWINNERMITTLUNG: {
                TITEL: 'Angaben zur Gewinnermittlung',
                HINWEIS: 'Die Eröffnungsbilanz ist gemäß § 5b Absatz 1 Satz 4 EStG nach amtlich vorgeschriebenen ' +
                    'Datensatz durch Datenfernübertragung zu übermitteln.',
                STAMMDATEN_STANDARD_YEAR_TITEL: 'Kein abweichendes Wirtschaftsjahr',
                STAMMDATEN_NONSTANDARD_YEAR_TITEL: 'Abweichendes Wirtschaftsjahr',
                BEGINN: 'Beginn:',
                GEWINNERMITTLUNGSART: {
                    TITEL: 'Gewinnermittlungsart',
                    NULL: 'Bitte wählen',
                    KEY_01: 'Einnahmenüberschussrechnung',
                    KEY_02: 'Betriebsvermögensvergleich',
                    KEY_03: 'Gewinnermittlung nach Durchschnittssätzen (nur bei Land- und Forstwirtschaft)',
                    KEY_04: 'Sonstige (zum Beispiel § 5a EStG)'
                },
                ERLAEUTERUNG_SONSTIGE: 'Erläuterung der sonstigen Gewinnermittlungsart (zum Beispiel § 5a EStG)',
                ABWEICHENDES_WJ: {
                    TITEL: 'Liegt ein abweichendes Wirtschaftsjahr vor?',
                    NULL: 'Keine Angabe',
                    JA: 'Ja',
                    NEIN: 'Nein',
                    BEGINN: 'Beginn des vom Kalenderjahr abweichenden Wirtschaftsjahres'
                },
                VALIDATION: {
                    BEGINN_AWJ_NOT_01_01: 'Das abweichende Wirtschaftsjahr darf nicht am 01.01. beginnen.'
                },
                ART_AUFTEILUNG: {
                    TITEL: 'Art der Aufteilung',
                    NULL: 'Bitte wählen',
                    KEY_1: 'Nach gezeichnetem Kapital',
                    KEY_2: 'Nach Bruchteilen',
                    KEY_3: 'Nach eingezahltem Kapital',
                    KEY_0: 'Anderer Aufteilungsschlüssel (Erläuterungen auf gesondertem Blatt)'
                }
            },
            KONZERN: {
                TITEL: 'Konzern',
                GEHOERT_ZU_KONZERN_SWITCH_FRAGEBOGEN_EUN: 'Das Einzelunternehmen gehört zu einem Konzern',
                GEHOERT_ZU_KONZERN_SWITCH_FRAGEBOGEN_BETPG: 'Die Gesellschaft gehört zu einem Konzern',
                GEHOERT_ZU_KONZERN_SWITCH_FRAGEBOGEN_PERSG: 'Die Gesellschaft gehört zu einem Konzern',
                GEHOERT_ZU_KONZERN_SWITCH_FRAGEBOGEN_KAPG: 'Die Gesellschaft gehört zu einem Konzern',
                GEHOERT_ZU_KONZERN_SWITCH_FRAGEBOGEN_KAPGAUS: 'Die Gesellschaft gehört zu einem Konzern',
                NAME_KONZERN: 'Name',
                HANDELSREGISTER: {
                    BEZEICHNUNG: 'Register',
                    NULL: 'Bitte wählen',
                    KEY_HRA: 'HRA [Handelsregister A]',
                    KEY_HRB: 'HRB [Handelsregister B]',
                    KEY_GSR: 'GsR [Gesellschaftsregister]',
                    KEY_PR: 'PR [Partnerschaftsregister]',
                    KEY_GNR: 'GnR [Genossenschaftsregister]',
                    KEY_VR: 'VR [Vereinsregister]'
                },
                HANDELSREGISTER_NUMMER: 'Registernummer',
                AMTSGERICHT: 'Ort des Amtsgerichts',
                AUSL_HRG: 'ausländisches Register inkl. Ort',
                AUSL_HRG_NR: 'Ordnungsbegriff (zum Beispiel Nummer)',
                INL_HRG: 'Ort des Amtsgerichts'
            },
            LOHNSTEUER: {
                TITEL: 'Angaben zur Anmeldung und Abführung der Lohnsteuer',
                HINWEIS: 'Dazu gehören auch Geschäftsführer, Vorstandsmitglieder, geringfügig beschäftigte ' +
                    'Personen und ehrenamtlich tätige Personen. Geschäftsführer einer ' +
                    'Komplementär-Kapitalgesellschaft, die gleichzeitig Kommanditisten der Kapitalgesellschaft & Co. ' +
                    'KG sind, sind nicht Arbeitnehmer im lohnsteuerlichen Sinne.',
                ZAHL_BUNDESREPUBLIK_ARBEITNEHMER: {
                    TITEL: 'Zahl der in der Bundesrepublik Deutschland beschäftigten Arbeitnehmer (gegebenenfalls Durchschnitt)'
                },
                ZAHL_ARBEITNEHMER: {
                    TITEL: 'Zahl der Arbeitnehmer',
                    ZAHL_AN_INSGESAMT: 'Zahl der Arbeitnehmer ingesamt (einschließlich Aushilfskräfte)',
                    DAVON_FAMILIENANGEHOERIGE: 'davon Familienangehörige',
                    DAVON_GERINGFUEGIG_BESCHAEFTIGTE: 'davon geringfügig Beschäftigte, für die 2 Prozent Pauschsteuer ' +
                        'an die Minijob-Zentrale abzuführen ist'
                },
                ZAHL_ARBEITNEHMER_KAPG: {
                    ZAHL_AN_INSGESAMT: 'Zahl der Arbeitnehmer insgesamt',
                    GLEICHZEITIG_GESELLSCHAFTER: 'Zahl der Arbeitnehmer, die gleichzeitig Gesellschafter oder deren Ehegatten sind',
                    DAVON_GERINGFUEGIG_BESCHAEFTIGTE: 'Zahl der geringfügig beschäftigten Arbeitnehmer, für die 2 Prozent' +
                      ' Pauschsteuer an die Minijob-Zentrale abzuführen ist',
                },
                BEGINN_LOHNZAHLUNGEN: {
                    TITEL: 'Beginn der Lohnzahlungen',
                    BEGINN_LOHNZAHLUNGEN: 'Beginn der Lohnzahlungen'
                },
                VORAUSSICHTLICHE_LOHNSTEUER: {
                    TITEL: 'Voraussichtliche Lohnsteuer im Kalenderjahr',
                    HINWEIS: 'Die Höhe der Lohnsteuer bestimmt den Anmeldungszeitraum gemäß § 41a EStG.',
                    VORAUSSICHTLICHE_LOHNSTEUER: 'Voraussichtliche Lohnsteuer'
                },
                VORAUSSICHTLICHE_LOHNSTEUER_KAPG: {
                    TITEL: 'Anmeldungszeitraum',
                    VORAUSSICHTLICHE_LOHNSTEUER: 'Voraussichtliche Lohnsteuer im Kalenderjahr'
                },
                LOHNSTEUERLICHE_BETRIEBSSTAETTE: {
                    TITEL: 'Lohnsteuerliche Betriebsstätte',
                    HINWEIS: 'Die lohnsteuerliche Betriebsstätte befindet sich in',
                    BEZEICHNUNG: 'Bezeichnung'
                }
            },
            GRUENDUNGSFORM: {
                TITEL: 'Gründungsform',
                GRUENDUNGSART: {
                    TITEL: 'Gründungsart',
                    NULL: 'Bitte wählen',
                    KEY_1: 'Neugründung',
                    KEY_2: 'Verlegung',
                    KEY_3: 'Übernahme (zum Beispiel Kauf, Pacht, Vererbung, Schenkung)',
                    KEY_4: 'Verschmelzung zur Neugründung oder sonstiger Gründungsvorgang'
                },
                GRUENDUNGSDATUM: 'Gründungsdatum',
                 HINWEIS: 'Die Erstellung eines Fragebogen zur steuerlichen Erfassung und ' +
                    'dessen Einreichung gehören bereits zur Gründung eines Unternehmens. ' +
                    'Das <strong>Gründungsdatum</strong> kann daher <strong>nicht</strong> in der Zukunft liegen. ' +
                    'Tragen Sie ggf. das heutige Datum ein.\n' +
                    'Beginnt die Tätigkeit erst zu einem späteren Zeitpunkt, ' +
                    'tragen Sie dies bitte im Bereich „Angaben zum Unternehmen“ im Feld „<strong>Beginn der Tätigkeit</strong>“ ein.\n' +
                    'Weitere Informationen finden Sie im Hilfe-Center-Dokument ' +
                    '<a href="https://help-center.apps.datev.de/documents/1038864" target="_blank" ' +
                    'rel="noopener noreferrer">1038864</a>.',
                VORHERIGESUNTERNEHMEN: {
                    TITEL: 'Vorheriges Unternehmen',
                    USTID: 'Umsatzsteuer-Identifikationsnummer',
                    STEUERNUMMERN: 'Steuernummer',
                    ADRESSE: 'Adresse',
                    VORHERIGES_UNTERNEHMEN_TYP: {
                        TITEL: 'Vorherige/r Inhaber/in bzw. Unternehmen',
                        NULL: 'Bitte wählen',
                        KEY_NATPERS: 'Natürliche Person',
                        KEY_NNATPERS: 'Nicht natürliche Person'
                    }
                }
            },
            NACHREICHUNG: {
                TITEL: 'Zusammenfassung der nachzureichenden Unterlagen',
                UNTERTITEL: 'Folgende Unterlagen werden nachgereicht',
                LASTSCHRIFTVERFAHREN: 'Ausgefüllte Teilnahmeerklärung für das SEPA-Lastschriftverfahren (SEPA-Lastschriftmandat)',
                VOLLMACHTSTEUERBERATUNG: 'Vollmacht über die steuerliche Beratung',
                EMPFANGSVOLLMACHT: 'Empfangsvollmacht',
                WEITEREBETRIEBSTAETTEN: 'Bei mehr als 10 Betriebsstätten: Gesonderte Aufstellung über Betriebsstätten',
                VERTRAGUEBERNAHMEUMWANDLUNG: 'Verträge über die Übernahme / Einbringung / Umwandlung / Verschmelzung des Unternehmens',
                WEITEREORGANSCHAFTLICHEVERBINDUNGEN: 'Aufstellung weiterer organschaftlicher Verbindungen (bei mehr als 2 Organschaften)',
                WEITEREONLINEMARKTPLAETZE: 'Übersicht weitere (mehr als 99) elektronische Schnittstellen',
                NACHWEISSTEUERSCHULDNERSCHAFTLEISTUNGSEMPFAENGER: 'Unterlagen für Nachweiserteilung zur ' +
                    'Steuerschuldnerschaft des Leistungsempfängers bei Bau-/Gebäudereinigungsleistungen',
                SACHGRUENDUNGSBERICHT: 'Sachgründungsbericht',
                ATYPISCHESTILLEBETEILIGUNG: 'Vertrag über atypisch stille Beteiligung',
                LISTEORGANGESELLSCHAFTEN: 'Liste der Organgesellschaften',
                GESELLSCHAFTSVERTRAG: 'Vertrag der Gesellschaft / Gemeinschaft',
                GEWINNABFUEHRUNGSVERTRAG: 'Gewinnabführungsvertrag',
                TREUHANDVERHAELTNISSE: 'Vertrag über Treuhandverhältnisse',
                VERTRAEG_GESELLSCHAFT_GESELLSCHAFTER: 'Verträge zwischen Gesellschaft und Gesellschafter ' +
                    '(zum Beispiel Gesellschafteranstellungs-, Miet-, Pacht- und/oder Darlehensverträge)',
                ERKLAERUNG_GESELLSCHAFTLICHE_VEREINBARUNGEN: 'Erklärung über die gesellschaftlichen Vereinbarungen',
                GESELLSCHAFTSVERTRAG_KOMPLEMENTAER_GMBH: 'Gesellschaftsvertrag der Komplementär-GmbH',
                WEITEREUNTERLAGEN: 'Weitere Unterlagen (bitte aufzählen)',
                AUSLANDISCHEMREGISTER: 'Auszug aus ausländischem Register',
                VERTRAGUBERREGIE: 'Vertrag/Verträge über Regie-/Lohnarbeiten, Tätigkeiten von Subunternehmen',
                GENEHMIGUNGSBESCHEID: 'Genehmigungsbescheid der Agentur für Arbeit',
                VERTRAGKAUFMIETE: 'Vertrag/Verträge über den Kauf, Miete, Pacht oder Leasing von Geschäftseinrichtungen oder Anlagen',
                BILANZ: 'zuletzt aufgestellte Bilanz',
                ARBEITSVERTRAG: 'Arbeitsvertrag/-verträge des ständigen Vertreters',
                VERTRAGPERSONEN: 'Vertrag/Verträge mit vom Unternehmen unabhängigen Personen',
                ANSAESSIGKEITSBESCHEINIGUNG: 'Ansässigkeitsbescheinigung'
            },
            NACHREICHUNG_KAPG: {
              VERTRAGUEBERNAHMEUMWANDLUNG: 'Umwandlungsbeschluss',
              GESELLSCHAFTSVERTRAG: 'Gesellschaftsvertrag / Satzung',
            },
            PARTNERSCHAFT: {
                PERSONENSTAND_TITEL: 'Familienstand',
                EHEPARNTER_ANGABEN_TOGGLE: 'Zusätzliche Angaben zur Ehe / Lebenspartnerschaft erfassen',
                EHEGATTE_TITEL: 'Ehegatte(in) / eingetragene(r) Lebenspartner(in)',
                EHEGATTE_ADRESSE_TITEL: 'Adresse',
                EHEPARNTER_ADRESSE_TOGGLE: 'Abweichende Adresse erfassen'
            },
            BISHERIGEPERSOENLICHEVERHAELTNISSE: {
                TITEL: 'Bisherige persönliche Verhältnisse',
                ZUGEZOGEN: {
                    TITEL: 'Der/Die Antragsteller(in) ist innerhalb der letzten zwölf Monate zugezogen.',
                    ZUGEZOGENAM: 'Umzugsdatum',
                    BISHERIGEADRESSE_TITEL: 'Frühere Adresse',
                    ORT: 'Postleitzahl, Wohnort'
                },
                STEUERNUMMER: {
                    TITEL: 'Der/Die Antragsteller(in) war in den letzten drei Jahren für Zwecke der Einkommensteuer steuerlich erfasst.',
                    BISHERIGESTEUERNUMMER_TITEL: 'Steuernummer'
                },
                ESTEHEPARTNER: {
                    TITEL: 'Abweichende Angaben für Ehegatte(in) / eingetragene(r) Lebenspartner(in)'
                }
            },
            BISHERIGEBETRIEBLICHEVERHAELTNISSE: {
                TITEL: 'Bisherige betriebliche Verhältnisse',
                VORTAETIGKEIT: {
                    TITEL: 'Ist in den letzten fünf Jahren schon ein Gewerbe, eine selbständige ' +
                        '(freiberufliche) oder eine land- und forstwirtschaftliche Tätigkeit ' +
                        'ausgeübt worden oder waren Sie an einer Personengesellschaft oder zu mindestens 1 ' +
                        'Prozent an einer Kapitalgesellschaft beteiligt?',
                    VORHANDEN:
                        {
                            NULL: 'Keine Angabe',
                            JA: 'Ja',
                            NEIN: 'Nein'
                        },
                    ART: 'Art der Tätigkeit/Beteiligung',
                    ORT: 'Ort',
                    DAUER_VON: 'Dauer vom:',
                    DAUER_BIS: 'Dauer bis:',
                    USTID: 'Umsatzsteuer-Identifikationsnummer'
                },
                STEUERNUMMER_TITEL: 'Steuernummer Vortätigkeit'
            },
            STEUERNUMMER: {
                TITEL: 'Steuernummer',
                WARNUNG: 'Bitte prüfen Sie die eingegebenen Daten. Nur eine gültige Finanzamt- und Steuernummer kann übermittelt werden.'
            },
            FESTSETZUNG_VORAUSZAHLUNG: {
                TITEL: 'Angaben zur Festsetzung der Vorauszahlungen',
                VORAUS_EINKUENFTE_TITEL: 'Voraussichtliche Einkünfte aus',
                VORAUS_HOEHE_TITEL: 'Voraussichtliche Höhe der',
                GRUNDLAGE_VORAUSZAHLUNGEN: {
                    STPFL: 'Steuerpflichtige(r) im Jahr der Betriebseröffnung',
                    EHEPARTNER: 'Ehegatte(in) / Lebenspartner(in) im Jahr der Betriebseröffnung',
                    STPFL_FOLGEJAHR: 'Steuerpflichtige(r) im Folgejahr',
                    EHEPARTNER_FOLGEJAHR: 'Ehegatte(in) / Lebenspartner(in) im Folgejahr'
                },
                LANDFORSTWIRTSCHAFT: 'Land- und Forstwirtschaft',
                GEWERBEBETRIEB: 'Gewerbebetrieb',
                SELBSTAENDIGERARBEIT: 'Selbständiger Arbeit',
                NICHTSELBSTAENDIGERARBEIT: 'Nichtselbständiger Arbeit',
                KAPITALVERMOEGEN: 'Kapitalvermögen',
                VERMIETUNGVERPACHTUNG: 'Vermietung und Verpachtung',
                SONSTIGEEINKUENFTE: 'Sonstigen Einkünften (z.B. Renten)',
                SONDERAUSGABEN: 'Sonderausgaben',
                STEUERABZUGSBETRAEGE: 'Steuerabzugsbeträge',
                GRUENDJAHR: 'Pflichteingabe mindestens einer der Einkunftsarten nach § 13, 15, 18, 21 ' +
                    'EStG. Bitte machen Sie Angaben in mindestens einem der folgenden Felder zur Höhe der ' +
                    'voraussichtlichen Einkünfte des Steuerpflichtigen im Jahr der Betriebseröffnung: ' +
                    'Land- und Forstwirtschaft, Gewerbebetrieb, Selbständiger Arbeit, Vermietung und Verpachtung.',
                FOLGEJAHR: 'Pflichteingabe mindestens einer der Einkunftsarten nach § 13, 15, 18, 21 ' +
                    'EStG. Bitte machen Sie Angaben in mindestens einem der folgenden Felder zur Höhe der ' +
                    'voraussichtlichen Einkünfte des Steuerpflichtigen im Folgejahr: Land- und ' +
                    'Forstwirtschaft, Gewerbebetrieb, Selbständiger Arbeit, Vermietung und Verpachtung.'
            },
            GESETZLICHER_VERTRETER: {
                TITEL: 'Gesetzlicher Vertreter',
                ADD_GESETZLICHER_VERTRETER: 'Gesetzlichen Vertreter hinzufügen',
                NEW_GESETZLICHER_VERTRETER: 'Neuer gesetzlicher Vertreter',
                REMOVE_GESETZLICHER_VERTRETER: 'Gesetzlichen Vertreter löschen',
                WEITERE_ANGABEN_GESETZLICHER_VERTETER: {
                    TITEL: 'Weitere Angaben zum gesetzlichen Vertreter'
                },
                USTID: 'Umsatzsteuer-Identifikationsnummer'
            },
            ORTDESSITZES: {
                LABEL: 'Ort des Sitzes',
                TITEL: 'Ort des Sitzes'
            },
            TAETIGKEITSART: {
                TITEL: 'Art der ausgeübten Tätigkeit(en)',
                LABEL: 'Art der ausgeübten Tätigkeit(en) (genaue Bezeichnung des Gewerbezweiges)'
            },
            VERMOEGENSVERWALTEND: {
              TITEL: 'Die Gesellschaft ist ausschließlich vermögensverwaltend tätig',
              LABEL: 'Die Gesellschaft ist ausschließlich vermögensverwaltend tätig. Angaben im Bereich zur ' +
                'Anmeldung und Abführung der Umsatzsteuer sind nicht zu tätigen'
            },
            PERSON_EXTENDED: {
                GEBURTSDATUM: 'Geburtsdatum',
                BERUFLICHE_TAETIGKEIT: 'Berufliche Tätigkeit',
                IDENTIFIKATIONSNUMMER: 'Identifikationsnummer',
                GRUENDUNGSDATUM: 'Gründungsdatum',
                ART_DES_BETRIEBES: 'Art des Betriebes'
            },
            NOTARANGABEN: {
                TITEL: 'Angaben zum Notar'
            },
            ANTEILSEIGNER: {
                TITEL: 'Angaben zu den Anteilseignern',
                PERSONENTYP_TITEL: 'Anteilseigner',
                PERSONENTYP: {
                    NULL: 'Keine Angabe',
                    KEY_NATPERS: 'Natürliche Person',
                    KEY_NNATPERS: 'Nicht natürliche Person'
                },
                NATUERLICHE_PERSON_TITEL: 'Natürliche Person',
                JURISTISCHE_PERSON_TITEL: 'Nicht natürliche Person',
                LAUFENDE_NUMMER: 'Laufende Nummer(n) der Geschäftsanteile (soweit vorhanden)',
                HOEHE_BETEILIGUNG_TITEL: 'Höhe der Beteiligung',
                HOEHE_DER_BETEILIGUNG_NOMINELL: 'Höhe der Beteiligung nominell',
                HOEHE_DER_BETEILIGUNG_PROZENT: 'Höhe der Beteiligung in Prozent',
                SUMME_BETEILIGTER_ANTEILSEIGNER_TITEL: 'Summe',
                SUMME_BETEILIGTER_ANTEILSEIGNER: 'Summe der Beteiligungen aller Anteilseigner in Prozent',
                HINWEIS_TREUHANDVERHAELTNISSE: 'Bei Treuhandverhältnissen reichen Sie bitte den Vertrag nach.',
                HINWEIS_SUMME_DER_BETEILIGUNG_IN_PROZENT_MEHR_ALS_HUNDERT: 'Die Summe der Beteiligung in Prozent beträgt mehr als 100.',
                HINWEIS_MINDESTENS_EIN_ANTEILSEIGNER: 'Bitte machen Sie Angaben zu mindestens einem Anteilseigner.',
                HINWEIS_PERCENTAGE_SUM: 'Die Summe der bei den Anteilseignern angegebenen Anteile an ' +
                    'der Gesellschaft beträgt weniger als 99 %. Bitte prüfen Sie ihre Angaben und ' +
                    'ergänzen Sie gegebenenfalls fehlende Angaben zu weiteren Anteilseignern.',
                ADD_ANTEILSEIGNER: 'Anteilseigner hinzufügen',
                NEW_ANTEILSEIGNER: 'Neuer Anteilseigner',
                REMOVE_ANTEILSEIGNER: 'Anteilseigner löschen',
                WEITERE_ANGABEN_ANTEILSEIGNER: 'Weitere Angaben zum Anteilseigner',
                TREUHAND: {
                    TITEL: 'Liegen Treuhandverhältnisse vor?',
                    UNDEFINED: 'Kein Angabe',
                    JA: 'Ja',
                    NEIN: 'Nein'
                }
            },
            BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN: {
                TITEL: 'Beginn der Tätigkeit',
                DAUER_DER_TAETIGKEIT_IN_DER_BUNDESREPUBLIK_DEUTCHLAND: 'Dauer der Tätigkeit in der Bundesrepublik Deutschland',
                BEGINN: 'Beginn der Tätigkeit',
                EROEFFNUNGSBILLANZ_WIRTSCHAFTSJAHR_TITEL: 'Eröffnungsbilanz / Wirtschaftsjahr',
                LIEGT_ABW_WJ_VOR: 'Es liegt ein abweichendes Wirtschaftsjahr vor',
                NULL: 'Keine Angabe',
                TRUE_VALUE: 'Ja',
                FALSE_VALUE: 'Nein',
                ABWEICHENDES_WJ_VOM: 'Abweichendes Wirtschaftsjahr vom',
                ABWEICHENDES_WJ_BIS: 'Abweichendes Wirtschaftsjahr bis',
                STAMMDATEN_STANDARD_YEAR_TITEL: 'Kein abweichendes Wirtschaftsjahr',
                STAMMDATEN_NONSTANDARD_YEAR_TITEL: 'Abweichendes Wirtschaftsjahr',
                HOEHE_GRUND_STAMMKAPITAL_TITEL: 'Höhe des Grund- oder Stammkapitals',
                HOEHE: 'Höhe des Grund- oder Stammkapitals',
                EINGEZAHLT: 'Darauf sind eingezahlt',
                DAUERTAETIGKEITOFFEN: 'Das voraussichtliche Ende der Tätigkeit ist bekannt.',
                END: 'Voraussichtliches Ende der Tätigkeit',
                WIRTSCHAFTJAHR_INFO: 'Die Eröffnungsbilanz ist gemäß § 5b Absatz 1 Satz 4 EStG nach ' +
                    'amtlich vorgeschriebenen Datensatz durch Datenfernübertragung zu übermitteln.',
                WAEHRUNGSANGABE: 'Währungsangabe'
            },
            ORGANSCHAFTSVERHAELTNISSE: {
                ORGANTRAEGER: {
                    TITEL: 'Organträger',
                    HINWEIS: 'Bitte eine Liste der Organgesellschaften unter Angabe der Steuernummer und - soweit erteilt - der ' +
                        'Umsatzsteuer-Identifikationsnummer (USt-IdNr.) gesondert übermitteln.',
                    GESELLSCHAFT_IST_ORGANTRAEGER: 'Die Gesellschaft ist Organträger',
                    ORGANTRAEGERSCHAFT_IST_KST_UND_GEWST: 'Die Organträgerschaft ist körperschaftsteuerlich und gewerbesteuerlich',
                    ORGANTRAEGERSCHAFT_IST_UMSTATZSTEUERLICH: 'Die Organträgerschaft ist umsatzsteuerlich'
                },
                ORGANGESELLSCHAFT: {
                    TITEL: 'Organgesellschaft/Organschaft',
                    PERSONENTYP_TITEL: 'Art der Organschaft',
                    PERSONENTYP: {
                        NULL: 'Keine Angabe',
                        KEY_NATPERS: 'Natürliche Person',
                        KEY_NNATPERS: 'Nicht natürliche Person'
                    },
                    NATUERLICHE_PERSON_TITEL: 'Natürliche Person',
                    NATUERLICHE_PERSON: {
                        ANREDE: {
                            LABEL: 'Anrede',
                            NULL: 'Bitte wählen',
                            KEY_1: 'Herr',
                            KEY_2: 'Frau'
                        },
                        VORNAME: 'Vorname',
                        NACHNAME: 'Nachname'
                    },
                    NICHT_NATUERLICHE_PERSON_TITEL: 'Nicht natürliche Person',
                    NICHT_NATUERLICHE_PERSON: {
                        NAME_ORGANTRAEGER: 'Name des Organträgers'
                    },
                    DATUMGEWINNABFVERTRAG: 'Datum des Gewinnabführungsvertrages',
                    BEGINNUSTORGANSCHAFT: 'Beginn der umsatzsteuerlichen Organschaft',
                    IST_KST_UND_GEWST_ORGANGESELLSCHAFT: 'Die Gesellschaft ist körperschaftsteuerliche ' +
                        'und gewerbesteuerliche Organgesellschaft. ' +
                        'Bitte Gewinnabführungsvertrag einreichen.',
                    UMSATZSTEUER_IDENTIFIKATIONSNUMMER: 'USt.-Identifikationsnummer',
                    UST_ORGANTRAEGER_MIT_KST_UND_GEWST_IDENTISCH: 'Der umsatzsteuerliche ' +
                        'Organträger ist mit dem körperschaftsteuerlichen und ' +
                        'gewerbesteuerlichen Organträger identisch',
                    GESELLSCHAFT_IST_UST_ORGANGESELLSCHAFT: 'Die Gesellschaft ist umsatzsteuerliche Organgesellschaft. ' +
                      'Der umsatzsteuerliche und der körperschaft- bzw. gewerbesteuerliche Organträger sind identisch.',
                    ERROR1: 'Es wurde angegeben, dass der umsatzsteuerliche Organträger mit dem ' +
                        'körperschaftsteuerlichen und gewerbesteuerlichen Organträger identisch ist. ' +
                        'In diesem Fall dürfen nur zu einem Organträger Angaben gemacht werden.',
                    ERROR2: 'Es kann nur genau einen körperschaftsteuerlichen und gewerbesteuerlichen ' +
                        'oder umsatzsteuerlichen Organträger geben, bitte prüfen Sie bei den ' +
                        'Organträgern die angegebene Art der Organschaft.'
                },
                ADD_ORGANTRAEGER: 'Organträger hinzufügen',
                NEW_ORGANTRAEGER: 'Neuer Organträger',
                REMOVE_ORGANTRAEGER: 'Organträger löschen'
            },
            BEZEICHNUNG_KG_ANGABEN: {
                BEZEICHNUNG_KG: 'Bezeichnung der KG'
            },
            ATYPISCHE_STILLE_BETEILIGUNG: {
                TITEL: 'Atypisch stille Beteiligung',
                CHECK: 'An der Gesellschaft besteht eine atypisch stille Beteiligung. ' +
                  'Fügen Sie den atypisch stillen Beteiligungsvertrag als Anhang (PDF) hinzu.'
            },
            FESTSETZUNG_ANGABEN: {
                TITEL: 'Festsetzung von Vorauszahlungen (Körperschaftsteuer, Gewerbesteuer)',
                UEBERSCHRIFT_GRUENDUNGSJAHR: 'für das Gründungsjahr (geschätzt)',
                UEBERSCHRIFT_FOLGEJAHR: 'für das Folgejahr (geschätzt)',
                GRUENDUNGSJAHR: 'für das Gründungsjahr (geschätzt)',
                FOLGEJAHR: 'für das Folgejahr (geschätzt)',
                GRUNDLAGE_VORAUSZAHLUNGEN: {
                    JAHRESUEBERSCHUSS: 'Jahresüberschuss / Steuerbilanzgewinn',
                    ZU_VERSTEUERNDES_EINKOMMEN: 'Zu versteuerndes Einkommen',
                    STEUERANRECHNUNGSBETRAEGE: 'Steueranrechnungsbeträge',
                    GEWERBEERTRAG: 'Gewerbeertrag'
                }
            },
            ANHAENGE:{
              NAVIGATION:{
                DOCUMENTS:'Einzureichende Unterlagen',
                ATTACHMENTS:'Digitale Dokumente',
              },
              TITEL: 'Digitale Dokumente',
              DOKUMENTE_ZIEL:'Dokumente hierher ziehen',
              DOKUMENTE_IMPORT:'Dokumente importieren',
              ODER:'oder',
              HOCHGELADENE:'Hochgeladene Dokumente',
              HOCHLADEN:'Dokumente werden hochgeladen...',
              LOESCHEN:'Löschen',
              LOESCHEN_DIALOG_TEXT: 'Wollen Sie das Dokument mit dem Dateinamen "{{fileName}}" wirklich löschen?',
              LOESCHEN_ABBRECHEN:'Abbrechen',
              LOESCHEN_DIALOG_TITEL:'Dokument löschen',
              WIRD_GELOESCHT:'wird gelöscht',
              RUECKMELDUNG: {
                TITEL: 'Rückmeldung zu digitalen Dokumenten',
                // eslint-disable-next-line max-len
                MAILINFO: 'Bei der Übermittlung kann es zu Verarbeitungsproblemen der Belege auf Seiten der Finanzverwaltung kommen. ' +
                  'Die Finanzverwaltung sendet in solchen Fällen elektronische Rückmeldungen. Diese werden ' +
                  'in der Online-Anwendung "Kommunikation Finanzverwaltung" angezeigt und sind über den Dokumentenkorb abrufbar. ' +
                  'Sie werden zusätzlich von der Finanzverwaltung über neue Rückmeldungen benachrichtigt. ' +
                  'Hierzu ist die Angabe einer E-Mail-Adresse notwendig. Weitere Informationen finden Sie im Hilfe-Center Dok.-Nr. ' +
                  '<a href="https://apps.datev.de/help-center/documents/1027340" target="_blank" rel="noopener noreferrer">1027340</a> '
              },
              ERRORS:{
                ADD_TITLE:'Fehler beim Hinzufügen des Dokumentes',
                DELETE_TITLE:'Fehler beim Löschen des Dokumentes',
                DELETE:'Es ist ein unbekannter Fehler beim Löschen des Dokumentes "{{fileName}}" aufgetreten.',
                LOAD_TITLE: 'Fehler beim Laden der Dokumente',
                LOAD: 'Es ist ein unbekannter Fehler beim Laden der Dokumente aufgetreten.',
                // eslint-disable-next-line max-len
                VOLUME_EXCEEDED_DROPZONE1: 'Weitere Dokumente können nicht importiert werden. Die von der Finanzverwaltung vorgegebene maximale Anzahl von 20 Dokumenten ist erreicht.',
                // eslint-disable-next-line max-len
                VOLUME_EXCEEDED_DROPZONE2:'Klicken Sie auf “Weiter” um auf der nächsten Seite auszuwählen, welche Unterlagen Sie per Post nachreichen möchten.',
                // eslint-disable-next-line max-len
                MIME_TYPE : 'Der Dateityp des Dokumentes "{{fileName}}" ist nicht zulässig. Erlaubt sind nur .pdf .tiff .tif .jpeg .jpg .png.',
                FILE_TOO_BIG: 'Das Dokument "{{fileName}}" überschreitet die zulässige Größe von {{document_size_mb}} MB.',
                FILENAME_TOO_LONG:'Der Name des Dokumentes "{{fileName}}" hat mehr als {{document_name_length}} Zeichen.',
                FILECOUNT_EXCEEDED: 'Die Anzahl der hochgeladenen Dokumente darf nicht über {{document_count}} liegen.',
                FILENAME_NOT_UNIQUE: 'Ein Dokument mit dem Namen "{{fileName}}" wurde bereits hochgeladen.',
                // eslint-disable-next-line max-len
                FILENAME_SPECIAL_CHARS: 'Das Dokument "{{fileName}}" kann nicht hochgeladen werden, da der Dateiname ein oder mehrere ungültige Zeichen enthält.',
                // eslint-disable-next-line max-len
                PAGES_EXCEEDED: 'Das Dokument "{{fileName}}" kann nicht hochgeladen werden, da es die maximal zulässige Anzahl von {{document_max_page_count}} Seiten überschreitet.',
                PASSWORD_PROTECTED: 'Das Dokument "{{fileName}}" kann nicht hochgeladen werden, da es mit einem Passwort geschützt ist.',
                VOLUME_EXCEEDED: 'Die maximale Größe aller hochgeladenen Dokumente darf 20 MB nicht überschreiten.',
                FILETYPE_CONTENT: 'Der Dateityp des Dokumentes "{{fileName}}" stimmt mit dessen Inhalt nicht überein.',
                UNKNOWN:'Es ist ein unbekannter Fehler aufgetreten.',
                FILE_CORRUPT: 'Das Dokument "{{fileName}}" ist nicht lesbar.',
                DOCUMENT_ERROR: 'Das Dokument "{{ fileName }}" konnte nicht verarbeitet werden. Wiederholen Sie die ' +
                  'Konvertierung der Ursprungsdatei ins PDF-Format und versuchen Sie das Hochladen erneut.',
                TASK_ALREADY_SUBMITTED: 'Der Auftrag ist bereits übermittelt. Es können keine weiteren Dokumente mehr hochgeladen werden.',
                FILENAME_EMPTY: 'Der Dokumentname ist leer.',
              },
              SUCCESSES:{
                ADD_TITLE: 'Dokument erfolgreich hochgeladen',
                ADD_TITLE_MULTI: 'Dokumente hochgeladen',
                ADD_MESSAGE: 'Das Dokument "{{fileName}}" wurde hinzugefügt.',
                ADD_MESSAGE_MULTI: 'Folgende Dokumente wurden erfolgreich hochgeladen:',
              }
            }
        },
        HINWEIS_UMSTELLUNG: {
            TITEL: 'Jährliche Mindestversionerhöhung des ELSTER-Moduls',
            ABSATZ_1: 'Ihr Entwurf wurde auf die neueste Version der Finanzverwaltung umgestellt. ' +
                      'Bitte prüfen Sie Ihre bisherigen Eingaben, da sich bei der Versionsumstellung einige Felder geändert haben können.',
            ABSATZ_2: 'Weitere Informationen finden Sie im Info-Dokument ',
            LINK_TEXT: 'Aktuelle Version von DATEV Fragebögen zur steuerlichen Erfassung.',
            CONFIRM: 'OK'
        },
        CURRENCY: {
            null: 'Keine Angabe',
            EUR: 'EUR',
            CHF: 'CHF',
            GBP: 'GBP',
            USD: 'USD',
            999: 'Sonstige nicht aufgeführte Währung'
        }
    },
    UTILS: {
        VALIDATION:
            {
                CONDITION_TRUE_DEFAULT: 'Die Bedingung ist nicht true.',
                REQUIRED_DEFAULT: 'Eingabe erforderlich.',
                REQUIRED_TRUE_DEFAULT: 'Eingabe erforderlich.',
                MAX_LENGTH_DEFAULT: 'Geben Sie maximal {{maxLength}} Zeichen ein.',
                MIN_LENGTH_DEFAULT: 'Geben Sie mindestens {{minLength}} Zeichen ein.',
                DATE_DEFAULT: 'Geben Sie das Datum im Format TT.MM.JJJJ ein.',
                MIN_DATE_DEFAULT: 'Das Datum darf nicht vor dem {{minDate}} liegen.',
                VALID_DATE_DEFAULT: 'Geben Sie ein gültiges Datum ein.',
                PATTERN_DEFAULT: 'Ungültiges Eingabeformat.',
                MAX_VALUE_DEFAULT: 'Maximalwert überschritten.'
            }
    }
};
